export const DEMO_ROLE_IDS = new Set([3, 4]);

export const GROUP_COLORS = [
  { label: "Bleu", value: "bg-blue-400", dot: "bg-blue-400" },
  { label: "Vert", value: "bg-green-400", dot: "bg-green-400" },
  { label: "Jaune", value: "bg-yellow-400", dot: "bg-yellow-400" },
  { label: "Rouge", value: "bg-red-400", dot: "bg-red-400" },
  { label: "Indigo", value: "bg-indigo-400", dot: "bg-indigo-400" },
  { label: "Violet", value: "bg-purple-400", dot: "bg-purple-400" },
  { label: "Rose", value: "bg-pink-400", dot: "bg-pink-400" },
  { label: "Orange", value: "bg-orange-400", dot: "bg-orange-400" },
  { label: "Cyan", value: "bg-teal-400", dot: "bg-teal-400" },
  { label: "Gris", value: "bg-gray-400", dot: "bg-gray-400" },
  { label: "Noir", value: "bg-black", dot: "bg-black" },
  { label: "Blanc", value: "bg-white", dot: "bg-white border border-slate-300" },
];

export const emptyGroupForm = {
  nom: "",
  horaire1: "",
  horaire2: "",
  annees_naissance: "",
  tarif_groupe: "",
  color_groupe: "bg-blue-400",
  is_active: true,
};

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function isDemoMode() {
  const user = getStoredUser();
  return DEMO_ROLE_IDS.has(Number(user?.role_id));
}

export function getFallbackSectionId(sectionId) {
  if (sectionId) return Number(sectionId);

  const user = getStoredUser();

  return user?.section_id ? Number(user.section_id) : null;
}

export function normalizeText(value = "") {
  return String(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function formatPrice(value) {
  if (value === null || value === undefined || value === "") return "—";

  const number = Number(value);

  if (Number.isNaN(number)) return `${value} €`;

  return `${number.toLocaleString("fr-FR")} €`;
}

export function getGroupColorClass(color) {
  return color || "bg-blue-400";
}

export function getGroupColorOption(color) {
  return (
    GROUP_COLORS.find((item) => item.value === color) ||
    GROUP_COLORS[0]
  );
}

export function mapGroupToForm(group) {
  return {
    nom: group?.nom || "",
    horaire1: group?.horaire1 || "",
    horaire2: group?.horaire2 || "",
    annees_naissance: group?.annees_naissance || "",
    tarif_groupe: group?.tarif_groupe ?? "",
    color_groupe: group?.color_groupe || "bg-blue-400",
    is_active:
      typeof group?.is_active === "boolean" ? group.is_active : true,
  };
}

export function buildGroupPayload(formData, sectionId) {
  return {
    nom: formData.nom,
    horaire1: formData.horaire1,
    horaire2: formData.horaire2,
    annees_naissance: formData.annees_naissance,
    tarif_groupe: formData.tarif_groupe,
    section_id: Number(sectionId),
    color_groupe: formData.color_groupe,
    is_active: Boolean(formData.is_active),
  };
}

export function sortGroups(groups = []) {
  return [...groups].sort((a, b) => {
    const nameA = String(a?.nom || "");
    const nameB = String(b?.nom || "");

    return nameA.localeCompare(nameB, "fr", { sensitivity: "base" });
  });
}

export function filterGroups(groups = [], searchTerm = "", statusFilter = "all") {
  const q = normalizeText(searchTerm.trim());

  return groups.filter((group) => {
    const isActive = group?.is_active !== false;

    const matchesStatus =
      statusFilter === "all" ||
      (statusFilter === "active" && isActive) ||
      (statusFilter === "inactive" && !isActive);

    const searchable = normalizeText(
      [
        group?.nom,
        group?.horaire1,
        group?.horaire2,
        group?.annees_naissance,
        group?.tarif_groupe,
      ]
        .filter(Boolean)
        .join(" ")
    );

    const matchesSearch = !q || searchable.includes(q);

    return matchesStatus && matchesSearch;
  });
}

export function getGroupsStats(groups = []) {
  const total = groups.length;
  const active = groups.filter((group) => group?.is_active !== false).length;
  const inactive = total - active;

  const withTwoSchedules = groups.filter(
    (group) => group?.horaire1 && group?.horaire2
  ).length;

  return {
    total,
    active,
    inactive,
    withTwoSchedules,
  };
}